export default __webpack_public_path__ + "static/media/mx-logo.cf9a56d9.png";